// extracted by mini-css-extract-plugin
module.exports = {"container":"_2_2XnYfe_C3tSud5CbCQVJ","icon":"_2PpgMBD1O2SkSdGS5_UGyg"};